import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Pagination } from "antd";

import UIEmptyState from "../../../components/EmptyState";

import TableRow from "./row";

class Table extends Component {
	static propTypes = {
		onPaginationChange: PropTypes.func,
		data              : PropTypes.array,
		pagination        : PropTypes.object,
		columns           : PropTypes.arrayOf(
			PropTypes.shape({
				title    : PropTypes.any,
				group    : PropTypes.string,
				className: PropTypes.string,
				width    : PropTypes.number.isRequired,
				visible  : PropTypes.bool,
				render   : PropTypes.func.isRequired,
				total    : PropTypes.func,
			}),
		),
		updateFuncionarioRow: PropTypes.func,
	};

	static defaultProps = {
		onPaginationChange: () => null,
		data              : [],
		pagination        : {},
		columns           : [],
	};

	state = {
		canScrollX: false,
	};

	componentDidMount() {
		window.addEventListener("resize", this.checkScrollX);
		this.checkScrollX();
	}

	componentDidUpdate() {
		this.checkScrollX();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.checkScrollX);
	}

	checkScrollX = () => {
		if( !this.scroller ) return;

		const canScrollX = this.scroller.scrollWidth > this.scroller.clientWidth + 1;

		if( canScrollX !== this.state.canScrollX )
		{
			this.setState({ canScrollX });
		}
	};

	cellProps = (column, extraClassName = "") => ({
		className: `daily-point-grid-cell ${column.className || ""} ${extraClassName}`,
		style    : {
			width   : column.width,
			minWidth: column.width,
			maxWidth: column.width,
		},
	});

	_renderHeader = (columns) => {
		const blocks = [];

		columns.forEach((column) => {
			const last = blocks[blocks.length - 1];

			if( column.group && last && last.group === column.group )
			{
				last.columns.push(column);
				last.width += column.width;
			}
			else
			{
				blocks.push({ group: column.group, columns: [column], width: column.width });
			}
		});

		return (
			<div className="daily-point-grid-header">
				{blocks.map((block, index) => {
					if( !block.group )
					{
						const [column] = block.columns;

						return (
							<div key={index} {...this.cellProps(column, "daily-point-grid-head-cell")}>
								{column.title}
							</div>
						);
					}

					return (
						<div key={index} className="daily-point-grid-group" style={{ width: block.width, minWidth: block.width }}>
							<div className="daily-point-grid-group-title">{block.group}</div>
							<div className="daily-point-grid-group-columns">
								{block.columns.map((column, col_index) => (
									<div key={col_index} {...this.cellProps(column, "daily-point-grid-head-cell")}>
										{column.title}
									</div>
								))}
							</div>
						</div>
					);
				})}
			</div>
		);
	};

	_renderTotal = (columns) => {
		const firstTotal = columns.findIndex((column) => typeof column.total === "function");

		if( firstTotal < 1 ) return null;

		const [labelColumn, ...fillerColumns] = columns.slice(0, firstTotal);
		const fillerWidth = fillerColumns.reduce((sum, column) => sum + column.width, 0);

		return (
			<div className="daily-point-grid-row daily-point-grid-total">
				<div {...this.cellProps(labelColumn, "daily-point-grid-total-label")}>
					<span>Total do dia</span>
				</div>
				{fillerWidth > 0 && <div className="daily-point-grid-cell" style={{ width: fillerWidth, minWidth: fillerWidth, maxWidth: fillerWidth }} />}
				{columns.slice(firstTotal).map((column, index) => (
					<div key={index} {...this.cellProps(column)}>
						{column.total ? column.total() : null}
					</div>
				))}
			</div>
		);
	};

	render() {
		const { data } = this.props;

		if( !data.length )
		{
			return (
				<UIEmptyState
					icon={<i className="fal fa-calendar-times" />}
					title="Nenhum registro encontrado"
					description="Não há registros de ponto para os filtros selecionados nesta data."
				/>
			);
		}

		const columns = this.props.columns.filter(column => !column.hasOwnProperty("visible") || column.visible);

		return (
			<div className="daily-point-table">
				<div ref={el => this.scroller = el} className="daily-point-grid">
					{this._renderHeader(columns)}
					<div className="daily-point-grid-body">
						{data.map((item, index) => (
							<TableRow
								key={item.id}
								index={index}
								columns={columns}
								updateRow={this.props.updateRow}
								reloadRow={this.props.reloadRow}
								item={item}
								dataDia={this.props.dataDia}
								fetchGetAll={this.props.fetchGetAll}
								newJoinColumn={this.props.newJoinColumn}
								removeBatida={this.props.removeBatida}
								journeyOpen={this.props.journeyOpen}
								updateFuncionarioRow={this.props.updateFuncionarioRow}
								fetchJustifications={this.props.fetchJustifications}
							/>
						))}
						{this._renderTotal(columns)}
					</div>
				</div>
				{this.state.canScrollX && (
					<p className="daily-point-table-hint">
						<i className="fal fa-long-arrow-left" />
						Role horizontalmente para ver todas as colunas
						<i className="fal fa-long-arrow-right" />
					</p>
				)}
				<Pagination
					{...this.props.pagination}
					showSizeChanger
					onChange={this.props.onPaginationChange}
					showTotal={(total, range) => `${range[0]}-${range[1]} de ${total} registros`}
				/>
			</div>
		);
	}
}

export default Table;
